import Vue from 'vue'
import App from './App.vue'
import router from './router'
import request from '@/utils/request'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

// 禁用移动端双击缩放和手势缩放
document.addEventListener('touchstart', function(event) {
  if (event.touches.length > 1) {
    // 如果是在图片预览组件中，允许捏合缩放
    const target = event.target
    if (target.closest('.pio-img') || target.closest('.pio-mask')) {
      return // 允许图片预览组件的捏合缩放
    }
    event.preventDefault() // 阻止其他地方的捏合缩放
  }
}, { passive: false })

document.addEventListener('gesturestart', function(event) {
  event.preventDefault()
})

document.addEventListener('gesturechange', function(event) {
  event.preventDefault()
})

document.addEventListener('gestureend', function(event) {
  event.preventDefault()
})

// 禁用双击缩放
let lastTouchEnd = 0
document.addEventListener('touchend', function(event) {
  const now = Date.now()
  if (now - lastTouchEnd <= 300) {
    // 如果是在图片预览组件中，允许双击
    const target = event.target
    if (target.closest('.pio-img') || target.closest('.pio-mask')) {
      lastTouchEnd = now
      return // 允许图片预览组件的双击
    }
    event.preventDefault()
  }
  lastTouchEnd = now
}, false)

// 使用Element UI
Vue.use(ElementUI)

Vue.prototype.$get = function(url, config = {}) {
  return request({
    url,
    method: 'get',
    ...config
  })
}

Vue.prototype.$post = function(url, data = null, config = {}) {
  // 如果data已经是FormData，直接使用（用于文件上传）
  if (data instanceof FormData) {
    return request({
      url,
      method: 'post',
      data: data,
      ...config
    })
  }
  
  // 将数据转换为表单格式
  let formData = null
  if (data) {
    formData = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })
  }
  
  return request({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    },
    ...config
  })
}


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
